import React from 'react'
import StaffCreate from '../staff_components/staff_create'

export default function StaffCreatePage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <StaffCreate />
    </div>
  )
}
